import { createIcon } from '@chakra-ui/react';

export const Benefit4 = createIcon({
  displayName: `Benefit4`,
  viewBox: `0 0 64.831 51.992`,
  path: (
    <g transform="translate(-0.5 -0.5)">
      <path
        d="M48.117,25.558A22.558,22.558,0,1,1,25.558,3,22.558,22.558,0,0,1,48.117,25.558Z"
        transform="translate(0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
      />
      <path
        d="M12,21a12.18,12.18,0,0,0,9.023,4.512A12.18,12.18,0,0,0,30.047,21"
        transform="translate(4.535 9.07)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
      />
      <path
        d="M13.5,13.5h.023"
        transform="translate(5.291 5.291)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
      />
      <path
        d="M22.5,13.5h.023"
        transform="translate(9.826 5.291)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
      />
    </g>
  ),
});
